export const UPDATE_INSTITUTION = 'UPDATE_INSTITUTION';
export const UPDATE_INSTITUTION_SUCCESS = 'UPDATE_INSTITUTION_SUCCESS';
export const UPDATE_INSTITUTION_FAILURE = 'UPDATE_INSTITUTION_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/actions/institutionsActionTypes.js